// src/App.js

import React, { Suspense } from "react"; // <-- 1. IMPORT Suspense
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Navbar from "./components/Navbar";
// We will also create a simple loading component
import PageLoader from "./components/PageLoader"; // <-- We will create this
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import ProductManager from './pages/admin/ProductManager';
import CategoryManager from './pages/admin/CategoryManager';

// --- 2. DYNAMICALLY IMPORT YOUR PAGES ---
const Home = React.lazy(() => import("./pages/home"));
const Shop = React.lazy(() => import("./pages/shop"));
const Community = React.lazy(() => import("./pages/community"));
const Contact = React.lazy(() => import("./pages/contact"));
const News = React.lazy(() => import("./pages/news"));
const Cybersecurity = React.lazy(() => import("./pages/cybersecurity"));
const SoftwareDevelopment = React.lazy(() => import("./pages/SoftwareDevelopment"));
const DigitalMarketing = React.lazy(() => import("./pages/Marketing"));
const CarAudioInstallation = React.lazy(() => import("./pages/CarAudioInstallation"));
const SecuritySystemSetup = React.lazy(() => import("./pages/SecuritySystemSetup"));
 


function App() {
  return (
    <Router>
      <Toaster /* ...your existing toaster config... */ />
      <Navbar />

      {/* --- 3. WRAP YOUR ROUTES IN A SUSPENSE FALLBACK --- */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/community" element={<Community />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/services/cybersecurity" element={<Cybersecurity />} />
          <Route path="/services/software" element={<SoftwareDevelopment />} />
          <Route path="/services/marketing" element={<DigitalMarketing />} />
          <Route path="/services/caraudio" element={<CarAudioInstallation />} />
          <Route path="/services/security" element={<SecuritySystemSetup />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
        {/* Redirect /admin to /admin/products by default */}
        <Route index element={<Navigate to="/admin/products" replace />} />
        <Route path="products" element={<ProductManager />} />
        <Route path="categories" element={<CategoryManager />} />
      </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;